import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScanLine, Search } from 'lucide-react';
import QRScanner from '../components/QRScanner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

// Faceplate QR holds ".../serials/<SERIAL>"; plain-text QR/barcodes are treated as the serial itself.
export const serialFromScan = (text) => {
  const t = (text || '').trim();
  const m = t.match(/\/serials\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : t;
};

export default function ScanSerialPage() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const go = (s) => { const v = serialFromScan(s); if (v) nav(`/serials/${encodeURIComponent(v)}`); };
  return (
    <div className="max-w-md mx-auto space-y-5 pt-4" data-testid="scan-serial-page">
      <div>
        <h1 className="text-2xl font-bold">Serial lookup</h1>
        <p className="text-sm text-slate-500">Scan the QR on a faceplate or type the serial to open the unit's record, warranty and repairs.</p>
      </div>
      <Button onClick={() => setOpen(true)} className="w-full h-16 text-base bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="scan-serial-camera-btn"><ScanLine className="w-6 h-6 mr-2" /> Scan faceplate QR</Button>
      <form onSubmit={(e) => { e.preventDefault(); go(q); }} className="flex gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type serial e.g. PMP-2610-0001" autoCapitalize="characters" className="h-12 rounded-sm mono text-base" data-testid="scan-serial-input" />
        <Button type="submit" className="h-12 rounded-sm" variant="outline" data-testid="scan-serial-go-btn"><Search className="w-5 h-5" /></Button>
      </form>
      <QRScanner isOpen={open} onClose={() => setOpen(false)} onScan={(t) => { setOpen(false); go(t); }} title="Scan faceplate QR" />
    </div>
  );
}
